module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-footer u-fixed u-pos-bl u-flex u-fit-w",
    class: [_vm.activeIndex === 0 ? 'is-hidden' : '', 'c-home-footer--' + _vm.activeIndex, _vm.$root.isTouch ? 'is-touch' : ''],
    on: {
      "mouseenter": function($event) {
        _vm.onMouseenter()
      },
      "mouseleave": function($event) {
        _vm.onMouseleave()
      }
    }
  }, [_c('div', {
    staticClass: "c-home-footer__progress u-absolute u-pos-bl u-zindex--2 u-fit-w u-bg--brand-primary",
    style: ({
      transform: 'scaleX(' + _vm.progressBarScale + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-footer__wrapper u-relative u-flex u-fit u-overflow-h u-bg--black"
  }, [_c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Prev",
      "type": "prev"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-w1of7"
  }), _vm._v(" "), _c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Prax",
      "index": 1,
      "activeIndex": _vm.activeIndex,
      "type": "number"
    }
  }), _vm._v(" "), _c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Spatial mining",
      "index": 2,
      "activeIndex": _vm.activeIndex,
      "type": "number"
    }
  }), _vm._v(" "), _c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Reward Calculation",
      "index": 3,
      "activeIndex": _vm.activeIndex,
      "type": "number"
    }
  }), _vm._v(" "), _c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Use prax",
      "index": 4,
      "activeIndex": _vm.activeIndex,
      "type": "number"
    }
  }), _vm._v(" "), _c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Time",
      "index": 5,
      "activeIndex": _vm.activeIndex,
      "type": "number"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-w1o7"
  }), _vm._v(" "), _c('app-home-footer-item', {
    staticClass: "u-w1of7",
    attrs: {
      "label": "Next",
      "type": "next",
      "disabled": _vm.isNextDisabled
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6197f324"}!./src/scripts/components/app-home-footer/template.html
// module id = 470
// module chunks = 0